// extracted by mini-css-extract-plugin
module.exports = {"aboveImage":"ParallaxImage_aboveImage__iv0l7","styleBg":"ParallaxImage_styleBg__m4gAw","behind":"ParallaxImage_behind__tDvsK"};